import React, { FC } from 'react'
import Pagination from 'components/SA/Pagination'
import ResultsCount from 'components/SA/Pagination/ResultsCount'
import SelectHitsPerPage from 'components/SA/Pagination/SelectHitsPerPage'
import { handleScrollToTop } from 'components/SA/Facets/helpers'
import styles from '../CollectionDetails.module.scss'
import useCollectionDetailsPagination from '../hooks/useCollectionDetailsPagination'
import { updateAppUrl } from 'lib/url/route'
import { useStore } from 'react-redux'

type CollectionPaginationHitsPerPageProps = {
  nextAppRoute: string
  urlPathString: string
}

const CollectionPaginationHitsPerPage: FC<CollectionPaginationHitsPerPageProps> = ({
  nextAppRoute,
  urlPathString,
}) => {
  const store = useStore()
  const state = store.getState()

  const {
    hitsPerPage,
    hitsTotal,
    currentPage,
    totalPages,
    urlWithParams,
  } = useCollectionDetailsPagination()

  const handleUrlWithParams = (pageParams) => urlWithParams({ urlPathString, ...pageParams })

  const handleChangeHitsPerPage = ({ value }) => {
    handleScrollToTop(() => {
      const href = urlWithParams({
        urlPathString,
        hitsPerPage: value,
        page: '',
      })
      updateAppUrl({
        app: nextAppRoute,
        href,
      })
    })
  }

  return (
    <div className={styles.paginationContainer}>
      <Pagination
        current={currentPage + 1}
        total={totalPages}
        onClickLink={({ currentHref }) => {
          handleScrollToTop(() => {
            updateAppUrl({
              app: nextAppRoute,
              href: currentHref,
            })
          })
        }}
        urlWithParam={handleUrlWithParams}
      />
      <ResultsCount
        hitsTotal={hitsTotal}
        hitsPerPage={hitsPerPage}
        category='Artwork'
        currentPage={currentPage}
      />
      {!!hitsTotal && (
        <SelectHitsPerPage
          hitsPerPage={hitsPerPage}
          handleChangeHitsPerPage={handleChangeHitsPerPage}
        />
      )}
    </div>
  )
}

export default CollectionPaginationHitsPerPage
